import { ContentDto } from '@app/modules/content-ai/content-ai.types';
import { useContentAiGetStationConfig } from '@mi-front/api-v2';

export function useContentAiPrompts(content: ContentDto) {
  const stationId = content.source.data.fragment?.station?.id as string;
  const query = useContentAiGetStationConfig(stationId);

  return query.data?.prompts ?? [];
}
